import { Component, input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

export interface DriverPetition {
  id: number;
  startDate: string;
  endDate: string;
  days: number;
  personal: boolean;
}

@Component({
  selector: 'app-driver-petition',
  imports: [MatButtonModule, MatIconModule],
  templateUrl: './driver-petition.component.html',
  styleUrls: ['./driver-petition.component.css', '../../../styles/layout.css'],
})
export class DriverPetitionComponent {
  petitions = input.required<DriverPetition>();
}
